import { render, staticRenderFns } from "./DescriptionForm.vue?vue&type=template&id=4929946c&scoped=true"
import script from "./DescriptionForm.vue?vue&type=script&lang=js"
export * from "./DescriptionForm.vue?vue&type=script&lang=js"
import style0 from "@wangeditor/editor/dist/css/style.css?vue&type=style&index=0&prod&lang=css&external"
import style1 from "./DescriptionForm.vue?vue&type=style&index=1&id=4929946c&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4929946c",
  null
  
)

export default component.exports